import React from 'react';
import sling from '../../assets/sling.PNG';
import balls from '../../assets/balls.PNG';
import portfoliorepo from '../../assets/portfoliorepo1.png';


const Experiments = () => {
  return (
    <section id="experiments" className="my-5">
    <div className="container-lg">
      <div className="text-center">
        <h2>FUN EXPERIMENTS</h2>
        <p>Check out these fun projects I have been tinkering with.</p>
    </div>

    <div className="my-5 mt-xs-2 row d-flex justify-content-around">
        <div className="mt-4 col-md-4 col-sm-10 col-xs-12">
          <div className="card">
            <img className="card-img-top img-fluid" src={sling} alt="sling"/>
            <div className="card-body text-center">
              <h5 className="card-title">Ballista</h5>
              <p className="card-text text-start">Ballista is a simple slingshot game made using Javascript Physics Engines p5.js and Matter.js (Only desktop-friendly)</p>
              <p className="card-text fw-bold">Tech Stack: Matter.js, p5.js</p>
              <a href="https://slingshot-matterjs.netlify.app/" target="_blank" rel="noreferrer" className="btn btn-outline-secondary">Visit Website</a>
            </div>
          </div>
        </div>

        <div className="mt-4 col-md-4 col-sm-10 col-xs-12">
          <div className="card">
            <img className="card-img-top" src={balls} alt="balls"/>
            <div className="card-body mt-4 text-center">
              <h5 className="card-title mt-2">Fun with p5 engine</h5>
              <p className="card-text text-start">Fun experiment with p5 physics engine where random balls get generated on mouse drag (Only desktop-friendly)</p>
              <p className="card-text fw-bold">Tech Stack: Matter.js, p5.js</p>
              <a href="https://physics-engine-experiment.netlify.app/" target="_blank" rel="noreferrer" className="btn btn-outline-secondary">Visit Website</a>
            </div>
          </div>
        </div>

        <div className="mt-4 col-md-4 col-sm-10 col-xs-12">
          <div className="card">
            <img className="card-img-top img-fluid" src={portfoliorepo} alt="portfoliorepo"/>
            <div className="card-body mt-3 text-center">
              <h5 className="card-title">Portfolio Repo</h5>
              <p className="card-text text-start">A repository of people's portfolios which showcases their work and story.</p>
              <p className="card-text fw-bold">Tech Stack: Javascript</p>
              <a href="https://portfolio-repository.netlify.app/" target="_blank" rel="noreferrer" className="btn btn-outline-secondary">Visit Website</a>
            </div>
          </div>
        </div>

    </div>
    </div>
</section>

  )
}

export default Experiments